<template>
  <div class="referral center-just">
    <div class="column content">
      <!-- <el-image
        :src="$domain + 'static/noten/website/home/index1_title4_img.png'"
        style="width: 1066px;height: 129px;align-self: center;cursor: pointer;"
      ></el-image> -->
      <div>
        <div class="center-just box-title" style="caret-color: transparent;">
          教育宗旨
        </div>
        <div class="center-just title-info" style="caret-color: transparent;">
          通过编程教育，培养儿童的计算思维、创造力、解决问题的能力和团队合作精神等能力，提高儿童的科学素养和创新意识。
        </div>
      </div>
      <div class="row" style="margin-top: 80px;">
        <div class="column" style="display: flex;justify-content: center;">
          <el-image
            :src="
              $domain + 'static/noten/website/home/gif/index1_box4_title1.png'
            "
            style="width: 206px;height: 40px;cursor: pointer;margin-bottom: 45px;"
          ></el-image>
          <div class="text">
            少儿编程教育的目标是通过编程教育，让儿童掌握计算思维的基本原理和方法，培养儿童的计算思维能力。
          </div>
        </div>
        <el-image
          :src="$domain + 'static/noten/website/home/gif/index1_box4_gif1.gif'"
          style="width: 650px;height: 400px;align-self: center;cursor: pointer;"
        ></el-image>
      </div>

      <div class="row">
        <el-image
          :src="$domain + 'static/noten/website/home/gif/index1_box4_gif2.gif'"
          style="width: 650px;height: 400px;align-self: center;cursor: pointer;"
        ></el-image>
        <div class="column" style="display: flex;justify-content: center;">
          <el-image
            :src="
              $domain + 'static/noten/website/home/gif/index1_box4_title2.png'
            "
            style="width: 180px;height: 40px;cursor: pointer;margin-bottom: 45px;"
          ></el-image>
          <div class="text">
            少儿编程教育的目的是通过编程创作，让儿童了解创新的过程和方法，培养儿童的创造力和想象力。
          </div>
        </div>
      </div>

      <div class="row">
        <div class="column" style="display: flex;justify-content: center;">
          <el-image
            :src="
              $domain + 'static/noten/website/home/gif/index1_box4_title3.png'
            "
            style="width: 266px;height: 40px;cursor: pointer;margin-bottom: 45px;"
          ></el-image>
          <div class="text">
            少儿编程教育的目标是通过编程解决实际问题的过程，让儿童学会分析问题、解决问题的方法和技能。
          </div>
        </div>
        <el-image
          :src="$domain + 'static/noten/website/home/gif/index1_box4_gif3.gif'"
          style="width: 650px;height: 400px;align-self: center;cursor: pointer;"
        ></el-image>
      </div>

      <div class="between">
        <el-image
          :src="$domain + 'static/noten/website/home/gif/index1_box4_gif4.gif'"
          style="width: 650px;height: 400px;align-self: center;cursor: pointer;"
        ></el-image>
        <div class="column" style="display: flex;justify-content: center;">
          <el-image
            :src="
              $domain + 'static/noten/website/home/gif/index1_box4_title4.png'
            "
            style="width: 243px;height: 40px;cursor: pointer;margin-bottom: 45px;"
          ></el-image>
          <div class="text">
            少儿编程教育的目的是通过合作编程项目，让儿童学会团队合作和沟通的技能，提高儿童的合作精神和团队意识。
          </div>
        </div>
      </div>

      <div class="between">
        <div class="column" style="display: flex;justify-content: center;">
          <el-image
            :src="
              $domain + 'static/noten/website/home/gif/index1_box4_title5.png'
            "
            style="width: 201px;height: 40px;cursor: pointer;margin-bottom: 45px;"
          ></el-image>
          <div class="text">
            少儿编程教育的目的是通过编程教育，让儿童了解科学的基本概念和原理，提高儿童的科学素养和科学认知能力。
          </div>
        </div>
        <el-image
          :src="$domain + 'static/noten/website/home/gif/index1_box4_gif5.gif'"
          style="width: 650px;height: 400px;align-self: center;cursor: pointer;"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.referral {
  height: 2425px;
  .content {
    width: 62.5%;
    .text {
      width: 70%;
      margin-left: 8%;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #6b7182;
      line-height: 33px;
    }
  }
}

.box-title {
  height: 46px;
  font-size: 46px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1a1a1a;
}

.title-info {
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin-top: 33px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/programming/box/box4.vue